import { createFetcher } from '@composables/createFetcher';

export type ContentPlayPayload = {
  id: string;
  thumbnailTime?: number;
};

export const useMuxMediaFetcher = () => {
  return createFetcher<ContentPlayPayload>({
    endpoint: '/post/playAsset',
    method: 'GET',
    requiresAuth: true,
    requiresArtistId: true,
    payloadAsQuery: true,
    validatePayload: (payload) => !!payload.id,
  });
};
